import React from 'react';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar'
}) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onCancel}
        >
            <div
                className="card p-xl"
                style={{ maxWidth: '500px', width: '90%' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-primary font-bold mb-md" style={{ fontSize: '1.5rem' }}>
                    {title}
                </h2>
                <p className="text-secondary mb-xl">
                    {message}
                </p>
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <button
                        className="btn btn-outline w-full"
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button
                        className="btn btn-primary w-full"
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
